import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

const SubmitButton = (props) => {
  const {
    variant,
    onClick,
    label,
    disabled,
    className,
  } = props;

  return (
    <Button className={className} variant={variant} onClick={onClick} disabled={disabled}>
      {label && <span>{label}</span>}
    </Button>
  );
};

SubmitButton.propTypes = {
  variant: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

SubmitButton.defaultProps = {
  variant: 'primary',
  onClick: null,
  disabled: false,
  className: null,
};

export default SubmitButton;
